import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ListContainer = styled.div<{ isOnWide?: boolean }>`
  ${({ isOnWide }) =>
    isOnWide &&
    css`
      display: flex;
      gap: var(--fd-space-space-2);
      padding: var(--fd-space-space-3) var(--fd-space-space-4);
      padding-bottom: 0;
    `}
`;
